<template>
  <v-card v-if="model.id" class="elevation-2" tile>
    <v-card-text>
      <v-row dense>
        <v-col cols="9">
          <p class="text-md-h4 text-sm-h5 text-center">Permisos del Rol</p>
        </v-col>
        <v-col cols="3">
          <v-layout justify-end>
            <v-btn v-if="showMainPermiss('accesos.roles.set-permiso')" color="green darken-2" @click="sendPermission" dark>
            <v-icon left>mdi-check-outline</v-icon> Guardar Permisos
            </v-btn>
          </v-layout>
        </v-col>
        <!-- v-for="(item, i) in permisosMain" :key="i" -->
        <v-col cols="12" sm="4" md="4">
          <v-card outlined max-height="600">
            <v-card-text>
              <v-row dense v-if="permisosMain.length > 0" >
                <v-col cols="12" class="scroll-box">
                  <v-treeview v-model="selection"
                    selection-type="independent"
                    :items="permisosMain"
                    return-object
                    selectable>
                  </v-treeview>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" sm="8" md="8">
          <v-card outlined max-height="600">
            <v-card-text>
              <v-row dense>
                <v-col cols="12" class="scroll-box">
                  <div cols="12" v-for="(item, i) in selection" :key="i"> {{ item.nombre }} - ( {{ item.descripcion }} ) </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>

import { mapGetters, mapActions } from 'vuex'
import { Permission } from '@/mixins/permissionMain'
export default {
  mixins: [Permission],
  props: ['model', 'onSuccess'],
  name: 'RolPermisosDetails',
  data: () => ({
    table: {
      header: {
        options: [
          { title: 'Nuevo', icon: 'mdi-plus', color: 'success', action: 'newDataRoles', code: 'accesos-usuarios.assign-rol' }
        ],
        titles: [
          { text: 'Nombre', value: 'nombre', class: 'black--text' },
          { text: 'Acceso', value: 'descripcion.special', class: 'black--text' },
          { text: 'Activo', value: 'Activo', class: 'black--text' },
          { text: '', value: 'ActionsGral', class: 'black--text' }
        ],
        loading: false,
        filter: true
      },
      body: {
        data: [],
        actions: [
          { title: 'Eliminar', icon: 'mdi-delete', color: 'error', action: 'daleteDataRol', code: 'libre', hidden: '' }
        ]
      },
      footer: {
        paging: true
      }
    },
    permisosMain: [],
    params: '?name=ARBOL',
    selection: []
  }),
  components: {
    // DataTableMain
  },
  mounted () {
    // this.ExecuteUrlTwo('POST/empresa/accesos/permisos/show')
    // this.ShowPermisos({ permisos: JSON.parse(localStorage.getItem('permisos')), tableMain: this.table })
  },
  methods: {
    ...mapActions(['GETObjectsServiceTwo']),
    showMainPermiss (permiso) {
      return this.ReadOnlyPermiso(JSON.parse(localStorage.getItem('permisos')), permiso)
    },
    sendPermission () {
      const item = { action: 'permissionsAssign', item: { rol_id: this.model.id, permisos: this.selection } }
      this.onSuccess(item)
    },
    successAction (item) {
      item.item = this.model
      this.onSuccess(item)
    },
    tableAction (item) {
      item.model = this.model
      this.onSuccess(item)
    },
    // ==========*==========*==========*==========*========== \\
    ExecuteUrlTwo (objet) {
      const router = this.get_urls[objet]
      console.log('router', router)
      this.GETObjectsServiceTwo({ url: router, params: this.params })
    }
  },
  computed: {
    ...mapGetters(['get_urls', 'get_object', 'get_objectsTwo'])
  },
  watch: {
    model (row) {
      this.selection = []
      if (row.permisos) {
        this.selection.push(...row.permisos)
        this.ExecuteUrlTwo('roles.permisos.show')
      }
    },
    get_objectsTwo (row) {
      this.permisosMain = []
      this.permisosMain.push(...row)
    }
  }
}
</script>
<style scoped>
.scroll-box {
  max-height: 500px;
  overflow-x: auto;
}
.scroll-box::-webkit-scrollbar {
  width: 10px;/* width of the entire scrollbar */
}

.scroll-box::-webkit-scrollbar-track {
  background: #d2d2d2;/* color of the tracking area */
  border-radius: 20px;
}
.scroll-box::-webkit-scrollbar-thumb {
  background-color: #3F51B5;  /* color of the scroll thumb */
  border-radius: 20px;       /* roundness of the scroll thumb */
  border: 3px solid #d2d2d2;/* creates padding around scroll thumb */
}
</style>
